import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { SeniorityTierOptionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const seniorityTierOptions = graphql(`
  query seniorityTierOptions {
    seniorityTierOptions {
      value
      label
    }
  }
`);

/**
 * Backend-served value/label options for the unified seniority-tier filter + column — the single
 * source of truth lives in `@stotles/data` `seniorityMapping.ts`. Rarely changes → cached forever.
 */
export function useSeniorityTierOptions(
  options?: UseQueryOptions<
    SeniorityTierOptionsQuery,
    unknown,
    SeniorityTierOptionsQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["seniorityTierOptions"],
    seniorityTierOptions,
    [undefined],
    { staleTime: Infinity, ...options },
  );
  return { data: data?.seniorityTierOptions, ...rest };
}
